var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3333 10.9993V10.3327C19.3333 9.39926 19.3333 8.93255 19.1517 8.57603C18.9919 8.26243 18.7369 8.00746 18.4233 7.84767C18.0668 7.66602 17.6001 7.66602 16.6667 7.66602H15.3333C14.3999 7.66602 13.9332 7.66602 13.5767 7.84767C13.2631 8.00746 13.0081 8.26243 12.8483 8.57603C12.6667 8.93255 12.6667 9.39926 12.6667 10.3327V10.9993M14.3333 15.5827V19.7493M17.6667 15.5827V19.7493M8.5 10.9993H23.5M21.8333 10.9993V20.3327C21.8333 21.7328 21.8333 22.4329 21.5608 22.9677C21.3212 23.4381 20.9387 23.8205 20.4683 24.0602C19.9335 24.3327 19.2335 24.3327 17.8333 24.3327H14.1667C12.7665 24.3327 12.0665 24.3327 11.5317 24.0602C11.0613 23.8205 10.6788 23.4381 10.4392 22.9677C10.1667 22.4329 10.1667 21.7328 10.1667 20.3327V10.9993",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete_icon.92f12f0ae9d745db94443fb45738aa44.svg";
export { ForwardRef as ReactComponent };